import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import { CustomerPermissionActionEnum, CustomerPermissionSubjectEnum, type components } from '@/libs/openapi/schema';
import { hasPermissions } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
}

export const organizationTeamPolicies = definePolicies((globalCtx: PolicyContext) => ({
  create: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_TEAM, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  update: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_TEAM, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
  delete: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.ORGANIZATION_TEAM, [
      CustomerPermissionActionEnum.DELETE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
